import axiosIns from '@/libs/axios'
import documentStoreModule from '../driver/documents/documentStoreModule'

export default {
  namespaced: true,
  actions: {
    async addtransactionBulks({ dispatch }, { transactionOperation, file, user_type }) {
      try {
        const res = await axiosIns.post('/transactions/bulk', {
          action: transactionOperation,
          user_type,
        })

        const { url } = res.data.data.metadata.upload
        const { id: bulkId } = res.data.data

        await dispatch('documents/s3Upload', {
          url,
          file,
        })
        if (transactionOperation !== 'waive_pending') {
          await axiosIns.post('/transactions/bulk/phone-mapping', {
            s3_url: url,
            action: transactionOperation,
            user_type,
          })
        }
        await axiosIns.put(`/transactions/bulk/${bulkId}/start`)

        return bulkId
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          console.error(err.response.data)
          throw err.response.data.message
        }
        throw err
      }
    },
    getTransactionBulks() {
      return axiosIns.get('transactions/bulk')
    },
    getTransactionBulkDetails(_, id) {
      return axiosIns.get(`transactions/bulk/${id}`)
    },
    waivePendingTransactions(_, {
      waive,
      waive_type,
      id,
      actor,
    }) {
      const temp = {
        waive,
        waive_type,
      }
      if (actor) {
        temp.actor = actor
      }
      return axiosIns.put(`transactions/pending-transactions/${id}`, temp)
    },
    async waiveAllDriverTransactions(_, { ids, waive_type }) {
      return axiosIns.post('transactions/pending-transactions/all', {
        ids,
        waive_type,
      })
    },
    fetchTripIdByBillId(_, id) {
      return axiosIns.get(`bills/snapshots/${id}`)
    },
    refund(_, payload) {
      return axiosIns.post('/payments/transactions/refund/', payload)
    },
  },
  modules: {
    documents: documentStoreModule,
  },
}
